import React, { Component } from 'react';
import '../../../styles/variables.css';
import '../Vacancies/BackendVacancies.css';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import database from "../../../firebase/firebase";
import {firebase} from "../../../firebase/firebase";
import {ShowNotification} from '../../../components/HandleNotifications';
import axios from 'axios';
import CustomUploadButton from 'react-firebase-file-uploader/lib/CustomUploadButton';
import {NotificationContainer} from 'react-notifications';
import profile from '../../../images/icons/no_image.png';
import { publishData } from '../../../actions/_company_actions';
axios.defaults.headers.post.Accept = "application/json";
axios.defaults.headers["Content-Type"] = "application/json";
axios.defaults.headers["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers["Access-Control-Allow-Methods"] = "ET, POST, PUT, DELETE";
axios.defaults.headers["Access-Control-Allow-Headers"] = "Authorization";

class BackendJobsActions extends Component {

    state = {
        onCreate: false,
        isUploading: false,
        progress: 0,
        company: {
            companyName: '',
            locationName: '',
            onCreate: true,
            data: '',
            companyAbout: '',
            active: true,
            companyEmail: '',
            objectID: '',
            companyLogo: '',
            companyWebsite: ''
        }
    } 

    handleInputChange = (e) => {
        const target = e.target;
        const name = target.name;
        const value = target.value;
        this.setState(prevState => {
            let company = Object.assign({}, prevState.company);
            company[name] = value;       
            return { company };                           
        });
    };

    componentWillMount(){
        this.setState({
            onCreate: this.props.companyData.onCreate,
            company:{
                companyName: this.props.companyData.companyName,
                locationName: this.props.companyData.locationName,
                onCreate: false,
                data: this.props.companyData.data,
                companyAbout: this.props.companyData.companyAbout,
                active: this.props.companyData.active,
                companyEmail: this.props.companyData.companyEmail,
                objectID: this.props.companyData.objectID,
                companyWebsite: this.props.companyData.companyWebsite,
                companyLogo: this.props.companyData.companyLogo === "" ? profile : this.props.companyData.companyLogo
            }
        })
    }

    handleUploadStart = () => this.setState({ isUploading: true, progress: 0 });
    handleProgress = progress => this.setState({ progress });
    handleUploadError = error => {
        this.setState({ isUploading: false });
        console.error(error);
    };
    handleUploadSuccess = (file) => {
        this.setState({ progress: 100, isUploading: false });
        firebase
        .storage()
        .ref(`companies/${this.props.companyData.objectID}/logo/`)
        .child(file)
        .getDownloadURL()
        .then(url => {
            this.setState(prevState => ({
                company: {
                    ...prevState.company,
                    companyLogo: url 
                }
            }))
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();  
        if(this.props.companyData.onCreate){
            const {password} = this.state;
            database.collection(`companies`)
            .doc(this.props.companyData.objectID)
            .set(this.state.company, {merge: true}).then(()=>{
                ShowNotification('success', 'Se actualizo la información exitosamente', 'Listo!');
            }).then(()=>{
                axios.request({
                    url: "https://us-central1-universia-dev.cloudfunctions.net/newPassword",
                    method: "POST",
                    data: {uid: this.props.companyData.objectID, password: password},
                    crossDomain: true
                }).then(res => {
                    window.location.reload(true)
                 })
            })
        }else {
            database.collection(`companies`)
            .doc(this.props.companyData.objectID)
            .set(this.state.company, {merge: true}).then(()=>{
                this.props.updateCompany(this.state.company)
            })
        }
    };

    render(){
        return(
            <div className="b-container">
                <div className="b-cards-container">
                    <div className='a-main-card'>
                        <div className="adt">
                            <p className="-title">{this.state.onCreate ? "Actualiza tu contraseña" :
                             "Tu empresa"}</p>
                             {this.state.onCreate ? <p className="warning_oncreate">De ser necesario puedes actualizar tu información tambien</p> :
                             null}
                        </div>
                        <div className="a-form-left">
                            <label className="a-label-company" htmlFor="companyName">Logo de la Empresa</label>
                            {this.state.company.companyLogo === "" ? null : <img src={this.state.company.companyLogo} 
                            alt="company-profile" className="company-profile"/>}
                            <CustomUploadButton
                                accept="image/png"
                                filename={file => new Date().getTime()}
                                storageRef={firebase.storage().ref(`companies/${this.props.companyData.objectID}/`).child('logo')}
                                onUploadStart={this.handleUploadStart}
                                onUploadError={this.handleUploadError}
                                onUploadSuccess={this.handleUploadSuccess}
                                onProgress={this.handleProgress}
                                style={{backgroundColor: 'var(--lapieza-color)', fontSize:'1.4rem', margin:'25px',
                                fontWeight: '800', color: 'white', padding: 10, borderRadius: 4}}
                            >
                                Actualizar logo
                            </CustomUploadButton>
                        </div>
                        <div className="a-form-left">
                            <label className="a-label-company" htmlFor="companyName">Nombre de la empresa</label>
                            <input id="companyName" type="text" name="companyName" onChange={this.handleInputChange}
                            className="a-input-company" value={this.state.company.companyName}/>
                            <label className="a-label-company" htmlFor="companyLocation">Ubicación</label>
                            <input id="companyLocation" type="text" name="locationName" onChange={this.handleInputChange}
                            className="a-input-company" value={this.state.company.locationName}/>
                            <label className="a-label-company" htmlFor="companyWebSite">Sitio web (No olvides omitir el  'https://' )</label>
                            <input id="companyWebSite" type="text" name="companyWebsite" onChange={this.handleInputChange}
                            className="a-input-company" value={this.state.company.companyWebsite}/>
                        </div>
                        {this.state.onCreate ? <div className="a-form-right">
                            <label className="a-label-company" htmlFor="companyPassword">Nueva contraseña</label>
                            <input id="companyPassword" type="password" name="password" onChange={this.handleInputChange}
                            className="a-input-company" value={this.state.password}/>
                        </div> : null}
                        <div className="clear"></div>
                        <div className="a-form-desc">
                            <label htmlFor="companyDescription" className="a-label-company">Descripciòn de la empresa</label>
                            <textarea className="asds" id="companyDescription" name="data" onChange={this.handleInputChange}
                            rows="3" value={this.state.company.data}></textarea>
                            <label htmlFor="companyHistory" className="a-label-company">Un poco de historia</label>
                            <textarea id="companyHistory" name="companyAbout" onChange={this.handleInputChange}
                            className="asds" rows="3" value={this.state.company.companyAbout}></textarea>
                        </div>
                        <div className="a-form-button">
                        <button className="a-button-company" onClick={this.handleSubmit}>Actualizar ahora</button>
                    </div>
                    </div>
                </div>
                <NotificationContainer />
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    companyData: state.company,
    id: state.auth.uid,
    jobs: state.vacancies
})

const mapDispatchToProps = (dispatch) => ({
    updateCompany: (newVals) =>  dispatch(publishData(newVals))
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BackendJobsActions));